import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }

import AutoComplete from "../components/AutoComplete.vue";
import TheWelcome from "../components/TheWelcome.vue";

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

let keywordInput = ref();
let keyword = ref("");

const router = useRouter();
const $toast = useToast();
function searchWithKeyword() {
  if (keyword.value.length < 3) {
    $toast.open({
      type: "error",
      position: "top",
      message: `Search keywords should be more than 3 characters!`,
    });
  } else {
    router.push({
      path: "/keyword-search/" + keyword.value,
      // force: true,
    });
  }
}

function onSelect(id: any) {
  keyword.value = id;
  searchWithKeyword();
}

function updateInput(input: string) {
  keyword.value = input;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("form", {
      class: "form-group",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("label", {
          class: "control-label col-auto",
          for: "keyword"
        }, "Gene name or keyword: ", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AutoComplete, {
            ref_key: "keywordInput",
            ref: keywordInput,
            id: "keyword",
            onOnSelect: onSelect,
            onUpdateInput: updateInput
          }, null, 512)
        ]),
        _createElementVNode("div", { class: "col-auto" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            onClick: searchWithKeyword
          }, " Browse ")
        ])
      ])
    ], 32),
    _createVNode(TheWelcome)
  ]))
}
}

})